enum CompanyEventToolbarAction {
  Return,
  Add,
  Outlook,
  Delete,
  Edit
}

export default CompanyEventToolbarAction;
